function recalc () {
	let doc = document.documentElement
	doc.style.fontSize = 100 * (doc.clientWidth / 1920)  + 'px'
}
recalc()
window.onresize = recalc